export const mapToCssModules = (cssModule: Array<string | undefined> = []): string => {
  if (!cssModule) return cssModule;

  return cssModule.filter((className: string | undefined) => !!className).join(' ');
};
